import React, { useEffect } from "react";
import CcButton from "./CcButton";

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  loading = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !loading) onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose, loading]);

  if (!open) return null;

  return (
    <div
      className="dialog-scrim"
      role="presentation"
      onClick={(event) => {
        if (loading) return;
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="dialog-card" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <div className="dialog-header confirm-dialog__header">
          <h2 className="dialog-title" id="confirm-dialog-title">
            {title}
          </h2>
          <CcButton variant="icon" aria-label="Close dialog" onClick={onClose} disabled={loading}>
            ✕
          </CcButton>
        </div>
        <div className="dialog-body">
          <p>{message}</p>
        </div>
        <div className="dialog-footer">
          <CcButton variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </CcButton>
          <CcButton variant="primary" onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </CcButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
